import { TrendingUp, Users, Target } from "lucide-react";
import { Button } from "@/components/ui/button";

interface InterstitialData {
  icon: "trending" | "users" | "target";
  title: string;
  stats: {
    number: string;
    label: string;
  }[];
  description: string;
}

interface InterstitialCardProps {
  data: InterstitialData;
  onContinue: (answer: 'no' | 'yes') => void;
}

const iconMap = {
  trending: TrendingUp,
  users: Users,
  target: Target
};

export const InterstitialCard = ({ data, onContinue }: InterstitialCardProps) => {
  const Icon = iconMap[data.icon];
  
  return (
    <div className="w-full max-w-2xl mx-auto animate-fade-in">
      <div className="glass-card p-8 md:p-12 rounded-2xl border-2 border-primary/20">
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-full bg-primary/10">
            <Icon className="h-12 w-12 text-primary" />
          </div>
        </div>
        
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center gradient-text">
          {data.title}
        </h2>
        
        <p className="text-center text-xl md:text-2xl mb-8">
          {data.description}
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {data.stats.map((stat, index) => (
            <div key={index} className="text-center p-4 rounded-lg bg-secondary/50">
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2 whitespace-nowrap">
                {stat.number}
              </div>
              <div className="text-sm text-muted-foreground">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => onContinue('no')}
            variant="outline"
            size="lg"
            className="px-8"
          >
            Nie, nie wiedziałem/-ałam
          </Button>
          <Button
            onClick={() => onContinue('yes')}
            size="lg"
            className="px-8"
          >
            Tak, wiedziałem/-ałam
          </Button>
        </div>
      </div>
    </div>
  );
};
